export class SourceAdapterContext {
    constructor(service, app) {
        this.service = service;
        this.app = app;
    }
    setLoading(value) {
        this.service.setLoading(value);
    }
    setSources(sources) {
        this.app.state.update((draft) => {
            if (!sources || !Array.isArray(sources) || sources.length === 0) {
                draft.sources.all = [];
                draft.sources.current = null;
            }
            else {
                draft.sources.all = sources;
                const current = sources.find((source) => { var _a; return source.id === ((_a = draft.sources.current) === null || _a === void 0 ? void 0 : _a.id); });
                if (!draft.sources.current || !current) {
                    draft.sources.current = sources[0];
                }
                else {
                    draft.sources.current = current;
                }
            }
        });
        this.service.notifySubscribers();
    }
    updateSources(id, source) {
        this.app.state.update((draft) => {
            var _a;
            if (((_a = draft.sources.current) === null || _a === void 0 ? void 0 : _a.id) === source.id) {
                Object.assign(draft.sources.current, source);
            }
            const draftSource = draft.sources.all.find((s) => s.id === source.id);
            if (draftSource) {
                Object.assign(draftSource, source);
            }
            else {
                draft.sources.all.push(source);
            }
        });
        this.service.notifySubscribers();
    }
}
//# sourceMappingURL=SourceAdapterContext.js.map